module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABAElEQVQ4T8XTO04DQQwG4N83gOvQInGDQGh4FJnfQBmgRaKFpOJhT8VDAsIBKLma0UqslILsbDQrMa3lT36NYOAnA3v4f9DdvwBskdz4q7u1KjSzhYjsAliQHFeB7v4BYE9E5iml6arZ96rQ3T8BjADMSJ53LbIItm1GxK2qXpSuohPMOb9FxD6AG5KXJayJrwTd/R3AOCKmqjrvg3WCZpZFZBIR16p6VQ02gLvfATiLiCdVPe6DFpeSc36MCAXwTPKohBbBBjCzexE5FZGXlNJh1dm0ye7+AOAEwCvJg6rDXkLbmX6r6nbV12uTfw99h+TmIOAgSykhy/FeW14H/AEaRlkVTjJFsgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back.png
// module id = DtD7
// module chunks = 1